import React from 'react';
import Header from '../../components/ui/Header';
import Seo from '../../components/Seo';

const TermsPage = () => {
  return (
    <>
      <Seo
        title="Terms of Service | Neevii"
        description="Neevii Terms of Service - Terms and conditions for using our AI accounting platform."
      />
      <div className="min-h-screen">
        <Header />
        <main className="pt-24 pb-16 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto prose prose-invert">
            <h1 className="text-4xl font-bold text-foreground mb-8">Terms of Service</h1>
            <p className="text-muted-foreground mb-4">Last updated: December 2025</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground mb-4">
                By accessing or using Neevii's AI-powered accounting services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">2. Description of Service</h2>
              <p className="text-muted-foreground mb-4">
                Neevii provides AI-powered accounting and bookkeeping automation tools designed to help businesses manage their financial data. Our service includes transaction categorisation, reporting, and integration with accounting software.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">3. User Responsibilities</h2>
              <p className="text-muted-foreground mb-4">You agree to:</p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use the service in compliance with applicable laws</li>
                <li>Not misuse or attempt to circumvent our security measures</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">4. Data and Privacy</h2>
              <p className="text-muted-foreground mb-4">
                Your use of our service is also governed by our Privacy Policy. We process your data in accordance with GDPR and applicable data protection regulations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">5. Limitation of Liability</h2>
              <p className="text-muted-foreground mb-4">
                Neevii provides tools to assist with accounting tasks but does not provide professional accounting or tax advice. Users are responsible for verifying the accuracy of outputs and consulting qualified professionals for financial decisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">6. Subscription and Payment</h2>
              <p className="text-muted-foreground mb-4">
                Paid features are billed according to your selected plan. Subscriptions renew automatically unless cancelled. Refunds are handled in accordance with our refund policy.
              </p>
              <p className="text-muted-foreground mb-4">
                For the Neevii AI Assistant Google Sheets sidebar, the Sheets Lite
                plan starts at GBP 4.99 / USD 5.99 per month (region-dependent
                pricing may apply). Billing renews monthly unless cancelled before
                renewal.
              </p>
              <p className="text-muted-foreground">
                Refund requests are assessed based on service usage and applicable
                consumer law. Contact <a href="mailto:legal@neevii.com" className="text-accent hover:underline">legal@neevii.com</a> and
                copy <a href="mailto:support@neevii.com" className="text-accent hover:underline">support@neevii.com</a> with
                your subscription details.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">7. Termination</h2>
              <p className="text-muted-foreground mb-4">
                We reserve the right to suspend or terminate accounts that violate these terms. You may cancel your account at any time through your account settings.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">8. Contact</h2>
              <p className="text-muted-foreground">
                For questions about these terms, contact us at{' '}
                <a href="mailto:legal@neevii.com" className="text-accent hover:underline">legal@neevii.com</a>
              </p>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default TermsPage;

